import { $api } from "../../../../services/request.config";
import { addObjKeyYoArrayAction } from "../../currentRequestControls/addObjKeyYoArray.action";


import moment from "moment";

export const getEmployeeWorkDaysThunkAction = ({periods, setDays, field}) => async(dispatch) => {
    try {
        // console.log(periods, setDays, field, index);
        // const response = await $api("v1/work-calendar/workdays",
        //     {
        //         params: {
        //             from: dateFrom,
        //             to: dateTo,
        //         },
        //     },
        // );
        const response = await $api.post("v1/requests/restdays/disabled-child-care/total-days/query",
            // [
            //     {
            //         from: moment(dateFrom).format("YYYY-MM-DD"),
            //         to: moment(dateTo).format("YYYY-MM-DD"),
            //     },
            // ]
            periods.map((element) => {
                return {
                    from: moment(element.dateFrom).format("YYYY-MM-DD"),
                    to: moment(element.dateTo).format("YYYY-MM-DD"),
                }
            }),
        );
        console.log(response);
        if (response.status === 200) {
            setDays((prevState) => {
                return   { ...prevState,
                    loading:false,
                    count: response.data.totalDays,
                    error: null,
                };
            });
            // if (index) {
                response.data.periods.forEach((period, index) => {
                    dispatch(addObjKeyYoArrayAction({
                        objKeyName: "workdaysCount",
                        arrayKey: null,
                        objKey: period.dayCount,
                        elementIndex: index,
                        fieldArray: "periods",
                    }));
                    dispatch(addObjKeyYoArrayAction({
                        objKeyName: "days",
                        arrayKey: null,
                        objKey: period.days,
                        elementIndex: index,
                        fieldArray: "periods",
                    }));
                    // dispatch(addObjKeyYoArrayAction({
                    //     objKeyName: "loader",
                    //     arrayKey: null,
                    //     objKey: false,
                    //     elementIndex: index,
                    //     fieldArray: "periods",
                    // }));
                });
            // }


        }
    }
    catch (error) {
        console.log(error);
        setDays((prevState) => {
                return   { ...prevState,
                    loading:false,
                };
            }
        );
        if(error?.response?.status === 400) {
        //     dispatch(addObjKeyYoArrayAction({
        //         objKeyName: "error",
        //         arrayKey: null,
        //         objKey: "Диапазон дат указан неверно",
        //         elementIndex: index,
        //         fieldArray: "periods",
        //     }));
        setDays((prevState) => {
                return   { ...prevState,
                    error:"Диапазон дат указан неверно",
                };
            }
        );
        } else {
        //     dispatch(addObjKeyYoArrayAction({
        //         objKeyName: "error",
        //         arrayKey: null,
        //         objKey: "Ошибка",
        //         elementIndex: index,
        //         fieldArray: "periods",
        //     }));
            setDays((prevState) => {
                    return   { ...prevState,
                        error:"Ошибка",
                    };
                }
            );
        }

    }
};
